import { render, staticRenderFns } from "./CardCheck.vue?vue&type=template&id=2bf7abd5&scoped=true&"
import script from "./CardCheck.vue?vue&type=script&lang=js&"
export * from "./CardCheck.vue?vue&type=script&lang=js&"
import style0 from "./CardCheck.vue?vue&type=style&index=0&id=2bf7abd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf7abd5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VForm,VTextField})
